import { useEffect, useState } from "react";
import { Link, useParams } from "react-router";
import { categories } from "../data/shows.js";
import NotFound from "./NotFound.jsx";
import AdBanner from "../components/AdsBanner.jsx";

const SECONDS = 10;
const R = 54;
const C = 2 * Math.PI * R;

export default function MediatorPage() {
  const { slug, id } = useParams();
  const category = categories.find((c) => c.slug === slug);
  const item = category?.items.find((i) => String(i.id) === id);

  // idle -> counting -> done
  const [phase, setPhase] = useState("idle");
  const [left, setLeft] = useState(SECONDS);

  useEffect(() => {
    if (phase !== "counting") return;
    const end = Date.now() + SECONDS * 1000;
    const t = setInterval(() => {
      const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      setLeft(remaining);
      if (remaining === 0) {
        clearInterval(t);
        setPhase("done");
      }
    }, 200);
    return () => clearInterval(t);
  }, [phase]);

  if (!item) return <NotFound />;

  const btn = "inline-flex items-center justify-center rounded-full px-10 py-4 font-display text-lg font-bold uppercase tracking-wider shadow-lg transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-glow";

  return (
    <section className="mx-auto max-w-xl text-center">
      <Link to={`/show/${slug}`} className="inline-block rounded-lg border border-line px-4 py-2 text-sm font-semibold transition hover:border-glow">
        ‹ Back
      </Link>
      {/* ads native ban */}
      <script async="async" data-cfasync="false" src="https://bellnewyork.org/21/e0480befad762d7e5f14a45960f9e186"></script>
      <div id="container-e0480befad762d7e5f14a45960f9e186"></div>
       

      <h1 className="mt-8 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
        {phase === "done" ? "Your link is ready" : "Please Wait"}
      </h1>
      <p className="mt-2 text-mist">{category.title} · {item.title}</p>

      <div className="relative mx-auto mt-10 size-48">
        <svg viewBox="0 0 120 120" className="size-full -rotate-90" aria-hidden="true">
          <circle cx="60" cy="60" r={R} fill="none" strokeWidth="8" className="stroke-line" />
          <circle
            cx="60" cy="60" r={R} fill="none" strokeWidth="8" strokeLinecap="round"
            className="stroke-glow"
            strokeDasharray={C}
            style={{
              strokeDashoffset: phase === "idle" ? 0 : C,
              transition: phase === "counting" ? `stroke-dashoffset ${SECONDS}s linear` : "none",
            }}
          />
        </svg>
        <div className="absolute inset-0 grid place-items-center">
          {phase === "done" ? (
            <span className="text-5xl text-glow">✓</span>
          ) : (
            <span key={left} className="count-pop font-display text-6xl font-extrabold tabular-nums" aria-live="polite">
              {left}
            </span>
          )}
        </div>
      </div>

      <div className="mt-10 min-h-16">
        {phase === "idle" && (
          <>
            <p className="mb-5 text-mist">Aage badhne ke liye Continue par click karo.</p>
            <button onClick={() => setPhase("counting")} className={`${btn} bg-glow text-ink hover:-translate-y-0.5`}>
              Click to continue
            </button>
          </>
        )}
        {phase === "counting" && <p className="text-mist">Link ready ho rahi hai… {left}s</p>}
        {phase === "done" &&
          (item.link ? (
            <a href={item.link} target="_blank" rel="noopener noreferrer" className={`${btn} page-enter bg-glow text-ink hover:-translate-y-0.5`}>
              Get Link
            </a>
          ) : (
            <button disabled className={`${btn} cursor-not-allowed bg-line text-mist shadow-none`}>
              Get Link
            </button>
            
          ))}

          {/* ads  ban call hai */}
          <AdBanner></AdBanner>
          {/* native ban */}

      </div>
      
      



      
    </section>
    
  );
}
